module.exports = __webpack_public_path__ + "static/media/category-supplementary.7bf27243.svg";